export default __webpack_public_path__ + "static/media/behance_large.b140e3fe.svg";